enum authType{
    LOGIN_START='LOGIN_START',
    LOGIN_SUCCESS = 'LOGIN_SUCCESS',
    LOGOUT_SUCCESS = 'LOGOUT_SUCCESS',
    LOGIN_LOGGED = 'LOGIN_LOGGED',
    LOGIN_FAILED = 'LOGIN_FAILED',
    UPDATE_AUTH = 'UPDATE_AUTH',
}
export default authType
